/* eslint-disable no-unused-vars */
import { Table, Divider } from 'antd';
import parser from 'html-react-parser';
import { useSelector } from 'react-redux';
import defaultImg from '../../assets/images/defaultImage.svg';

function LineItemsCard({ singleOrderData }) {
    const { preferences } = useSelector((state) => state.preferences);
    const columns = [
        {
            title: 'Items',
            dataIndex: ['sku'],
            render: (_, record) => (
                <div className="flex">
                    <div className="h-16 w-16 rounded-md">
                        {record.image ? (
                            <img src={record.image} alt={defaultImg} className="h-full w-full" />
                        ) : (
                            <img src={defaultImg} alt={defaultImg} className="h-full w-full" />
                        )}
                    </div>
                    <div className="ml-3">
                        <div className="mb-1 font-bold">{record.name}</div>
                        <div className="text-violet">category</div>
                        <div className="text-tertiary font-normal">SKU:{record.sku}</div>
                    </div>
                </div>
            ),
        },
        {
            title: 'Qty/Unit',
            dataIndex: ['price'],
            render: (text, record) => (
                <div className="">
                    <div className="mb-1 font-bold">
                        {parser(preferences.currency_symbol || '')} {record.price} X{' '}
                        {record.quantity}
                    </div>
                    <div className="text-violet">&nbsp;</div>
                    <div className="text-tertiary font-normal">&nbsp;</div>
                </div>
            ),
        },
        {
            title: 'Total',
            dataIndex: 'total',
            render: (text) => (
                <div className="">
                    <div className="mb-1 font-bold">
                        <strong>
                            {text}
                            {parser(preferences.currency_symbol || '')}
                        </strong>
                    </div>
                    <div className="text-violet">&nbsp;</div>
                    <div className="text-tertiary font-normal">&nbsp;</div>
                </div>
            ),
        },
    ];
    return (
        <>
            <div className="bg-white rounded-sm mt-30px pt-3 border border-primary">
                <Table
                    dataSource={singleOrderData.line_items}
                    columns={columns}
                    pagination={false}
                    rowKey={(record) => record.id}
                />
                {/* <Divider /> */}

                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="top-0 left-0">Gross Price</div>
                    <div className="absolute-right">
                        {singleOrderData.total} {parser(preferences.currency_symbol || '')}
                    </div>
                </div>
                <Divider className="m-0" />
                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="self-start text-tertiary">
                        <div>Discount</div>
                        <div className="font-light">-shirt</div>
                    </div>
                    <div className="pr-6 self-start absolute-right">
                        {singleOrderData.discount_total}
                    </div>
                </div>
                <Divider className="m-0" />
                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="self-end">Total Discount</div>
                    <div className="pr-6 absolute-right">{singleOrderData.discount_total}</div>
                </div>
                <Divider className="m-0" />
                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="self-end text-tertiary">Shipping (DHL)</div>
                    <div className="pr-6 absolute-right">{singleOrderData.shipping_total}</div>
                </div>
                <Divider className="m-0" />
                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="self-end text-tertiary">VAT</div>
                    <div className="pr-6 absolute-right">{singleOrderData.total_tax}</div>
                </div>
                <Divider className="m-0" />
                <div className="font-bold text-base px-30px py-20px relative flex justify-between items-center">
                    <div className="self-end">Cart Subtotal</div>
                    <div className="pr-2 absolute-right">
                        {singleOrderData.total}
                        {parser(preferences.currency_symbol || '')}
                    </div>
                </div>
                <Divider className="m-0" />
            </div>
        </>
    );
}

export default LineItemsCard;
